export default [
  {
    id: 4,
    title: "مشکل در خواندن اسکریپت",
    category: "اسکریپت",
    status: "در حال انتظار",
    createAt: "1400/07/02 15:00:16",
    updatedAt: "1400/07/02 19:20:16",
    question: `
    سلام
اسکریپت در سایت من بارگذاری نمیشود.
    `,
    answer: `
    سلام
در حال بررسی مشکل هستیم.
    `,
  },
  {
    id: 3,
    title: "دریافت فاکتور رسمی",
    category: "مالی",
    status: "پاسخ داده شده",
    createAt: "1400/06/10 20:10:16",
    updatedAt: "1400/06/11 09:20:16",
    question: `
    سلام
    به چه طریق میتوانم فاکتور رسمی پرداخت هایم را داشته باشم؟
    `,
    answer: `
    سلام
باید اطلاعات کاربری خود را به صورت کامل وارد کنید و در مرحله توسط تیم پشتیبانی اطلاعات شما بررسی و تایید میشود.
    `,
  },
  {
    id: 2,
    title: "مشکل در نمایش تبلیغ",
    category: "پشتیبانی",
    status: "بسته شده",
    createAt: "1400/04/20 09:04:16",
    updatedAt: "1400/04/21 10:24:16",
    question: `
    سلام
تبلیغ بنری من در سایت https://monirlock.ir/ نمایش داده نمی شود.
    `,
    answer: `
    سلام
ما سایت https://monirlock.ir/ بررسی کردیم و تبلیغ شما را مشاهده کردیم.احتمالا به خاطر اخلال در اینترنت این مشکل رخ داده است.
    `,
  },
  {
    id: 1,
    title: "نقش کاربر بررسی نشده",
    category: "مدیریت حساب",
    status: "بسته شده",
    createAt: "1400/02/23 21:37:16",
    updatedAt: "1400/02/23 22:15:16",
    question: `
    سلام
چرا نقش کاربری من هنوز در حال نقش کاربر بررسی نشده مانده است.
    `,
    answer: `
    سلام
شما هنوز نام و نام خانوادگی خود را وارد نکرده اید.
    `,
  },
];
